import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { Section, Reveal, SectionTitle } from './Section';
const B1 = 'https://cdn.magicpatterns.com/uploads/1i8EyurLhF25gLzpKAPAX4/BONO_1_CORRIGE.png';
const B2 = 'https://cdn.magicpatterns.com/uploads/1BBztrFNAgEHuxeUck1szw/BONO_2_CORRIGE.png';
const B3 = 'https://cdn.magicpatterns.com/uploads/anqUu7damBrrLfHi6p2Ets/BONO_3_CORRIGE.png';
const B4 = 'https://cdn.magicpatterns.com/uploads/fNtdZd6BDXW1E97pJxGdqm/BONO_4_CORRIGE.png';
const B5 = 'https://cdn.magicpatterns.com/uploads/3iMZVfy16y6UB1nvDMPHz1/BONO_5_CORRIGE.png';
const B6 = 'https://cdn.magicpatterns.com/uploads/7UYUZj7uUHcPJrfB3RUWww/BONO_6_CORRIGE.png';
const bonuses = [{
  n: 'Bono 1',
  img: B1,
  title: 'La Biblioteca del Docente Evaluador™',
  desc: 'Sistema de organización inteligente para no volver a crear una evaluación desde cero.',
  value: 'USD 29'
}, {
  n: 'Bono 2',
  img: B2,
  title: 'ChatGPT para Corregir Evaluaciones™',
  desc: '150 prompts para crear, adaptar y mejorar evaluaciones utilizando IA.',
  value: 'USD 39'
}, {
  n: 'Bono 3',
  img: B3,
  title: 'El Manual del Docente Productivo™',
  desc: 'Sistema práctico para recuperar entre 5 y 10 horas cada semana.',
  value: 'USD 27'
}, {
  n: 'Bono 4',
  img: B4,
  title: 'El Banco Maestro de Instrumentos de Evaluación™',
  desc: 'Aprende cuándo utilizar rúbricas, listas de cotejo y escalas con ejemplos prácticos.',
  value: 'USD 37'
}, {
  n: 'Bono 5',
  img: B5,
  title: 'Evaluación Relámpago para Proyectos™',
  desc: 'Técnicas y herramientas listas para evaluar proyectos de forma rápida, clara y significativa.',
  value: 'USD 27'
}, {
  n: 'Bono 6',
  img: B6,
  title: 'Portafolio del Docente Exitoso™',
  desc: 'Organiza, evidencia y destaca tu trabajo docente de manera profesional y estratégica.',
  value: 'USD 29'
}];
export function Bonuses() {
  return <Section className="bg-brand-cream" data-id="element-44">
      <Reveal className="text-center" data-id="element-45">
        <span className="mx-auto mb-3 inline-flex items-center gap-1.5 rounded-full bg-brand-pink/15 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-brand-pink" data-id="element-46">
          <GiftIcon className="h-4 w-4" data-id="element-47" />
          Regalo de lanzamiento
        </span>
        <SectionTitle data-id="element-48">Además recibirás estos 6 Bonos Exclusivos</SectionTitle>
      </Reveal>

      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-49">
        {bonuses.map((b, i) => <Reveal key={b.n} delay={i * 0.05} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-brand-purple/10" data-id="element-50">
            {b.img ? <div className="flex items-center justify-center bg-white px-4 pt-4" data-id="element-51">
                <img src={b.img} alt={b.title} className="h-44 w-full object-contain" loading="lazy" data-id="element-52" />
              </div> : <div className="flex h-44 items-center justify-center bg-brand-purple/5" data-id="element-53">
                <GiftIcon className="h-16 w-16 text-brand-purple/30" data-id="element-54" />
              </div>}
            <div className="flex flex-1 flex-col p-5" data-id="element-55">
              <span className="mb-1.5 w-fit rounded-full bg-brand-purple px-2.5 py-0.5 text-[11px] font-extrabold uppercase text-white" data-id="element-56">
                {b.n}
              </span>
              <h3 className="font-display text-base font-extrabold leading-tight text-brand-purpleDark" data-id="element-57">
                {b.title}
              </h3>
              <p className="mt-1.5 flex-1 text-sm font-semibold text-brand-purpleDark/70" data-id="element-58">
                {b.desc}
              </p>
              <p className="mt-3 text-sm font-extrabold" data-id="element-59">
                <span className="text-brand-purpleDark/50 line-through" data-id="element-60">
                  Valor: {b.value}
                </span>{' '}
                <span className="text-brand-green" data-id="element-61">GRATIS</span>
              </p>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}